const UniqLinkConstants = {
    generateUUID: () => {
        // Generate a random UUID-like string with 60-80 characters
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const length = 65; // Random length between 60-80
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    },
};

export default UniqLinkConstants;
